<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
import AppShell from "../components/AppShell.vue";
import { useTenantStore } from "../stores/tenants.js";

const tenantStore: ReturnType<typeof useTenantStore> = useTenantStore();
</script>

<template>
  <AppShell>
    <header class="page-heading">
      <div>
        <p class="eyebrow">System administration</p>
        <h1>Dashboard</h1>
        <p>Installation-wide health and usage at a glance.</p>
      </div>
      <span class="status-pill"><span></span> API connected</span>
    </header>

    <section class="metric-grid metric-grid--four" aria-label="System summary">
      <article class="metric-card metric-card--accent">
        <span class="metric-card__label">Tenants</span>
        <strong>{{ tenantStore.tenants.length }}</strong>
        <span>Known to this installation</span>
      </article>
      <article class="metric-card">
        <span class="metric-card__label">Probes</span>
        <strong>—</strong>
        <span>Awaiting probe inventory API</span>
      </article>
      <article class="metric-card">
        <span class="metric-card__label">Probe requests / min</span>
        <strong>—</strong>
        <span>Awaiting request telemetry</span>
      </article>
      <article class="metric-card">
        <span class="metric-card__label">Database size</span>
        <strong>—</strong>
        <span>Awaiting database telemetry</span>
      </article>
    </section>

    <section class="content-panel placeholder-panel">
      <p class="eyebrow">System health</p>
      <h2>Operational telemetry is prepared</h2>
      <p>
        Probe totals, request rate, and database size will be connected when the corresponding
        system metrics endpoint exists.
      </p>
    </section>
  </AppShell>
</template>
